import { Reveal } from "./Reveal";
import { RotateCcw } from "lucide-react";

// Continuous feedback loop: Listening -> Reporting -> Distribution -> Convening -> Accountability
export const FeedbackLoop = ({ items, active }) => {
  return (
    <div data-testid="feedback-loop" className="relative">
      <div className="grid gap-3 md:grid-cols-5 md:gap-2">
        {items.map((step, i) => (
          <Reveal key={i} active={active} delay={0.15 + i * 0.13}>
            <div className="relative flex h-full flex-col border border-ink bg-surface p-4">
              <span className="mono text-xs text-canary" style={{ WebkitTextStroke: "0.4px #111" }}>
                {String(i + 1).padStart(2, "0")}
              </span>
              <h4 className="font-display mt-2 text-lg leading-tight tracking-tight">{step.title}</h4>
              <p className="mt-1.5 text-[0.8rem] leading-relaxed text-stone">{step.desc}</p>
              {i < items.length - 1 && (
                <div className="absolute -right-2 top-1/2 z-10 hidden h-4 w-4 -translate-y-1/2 rotate-45 border-r border-t border-ink bg-surface md:block" />
              )}
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal active={active} delay={0.9} className="mt-4">
        <div className="flex items-center gap-2 text-stone">
          <RotateCcw className="h-4 w-4" />
          <span className="mono text-xs uppercase tracking-widest">
            Accountability feeds the next cycle of listening — a continuous loop
          </span>
        </div>
      </Reveal>
    </div>
  );
};
